import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';
import DesktopCockpitHeader from '../DesktopCockpitHeader';
import { GlobalXPIndicator } from '../RewardFX';
import { ReferenceDock } from '../reference/ReferenceShell';
import architecture from '@/assets/chances/architecture.webp';
import './OpportunityScene.css';

export { isOpportunityScene } from '@/lib/opportunityDesign';

export default function OpportunityScene({ children, unread, tools, mode = "employee", extraSections }) {
  const { pathname } = useLocation();
  // Radix portals retain their native focus/viewport/save guards. Theme only
  // while this route is mounted; never leak the scene onto another work area.
  useLayoutEffect(() => {
    const previous = document.body.getAttribute('data-opportunity-scene');
    document.body.setAttribute('data-opportunity-scene', 'true');
    return () => {
      if (previous === null) document.body.removeAttribute('data-opportunity-scene');
      else document.body.setAttribute('data-opportunity-scene', previous);
    };
  }, []);
  return <div className="opportunity-scene" data-testid="opportunity-scene">
    <svg className="chance-architecture" viewBox="0 111 1915 710" preserveAspectRatio="xMidYMid slice" aria-hidden="true">
      <image href={architecture} width="1915" height="821"/>
    </svg>
    <DesktopCockpitHeader reference workScene mode={mode} extraSections={extraSections} unread={unread} tools={tools} decoration={
      <svg className="chance-header-architecture cockpit-header-housing" viewBox="0 0 1915 111" preserveAspectRatio="none" aria-hidden="true">
        <image href={architecture} width="1915" height="821"/>
      </svg>
    }/>
    <GlobalXPIndicator/>
    <main className="chance-content" key={pathname}>{pathname.startsWith('/m/opportunities')?children:<div className="chance-continuation">{children}</div>}</main>
    {mode !== "admin" && <div className="chance-mobile-dock"><ReferenceDock/></div>}
  </div>;
}
